export default {
  LINE: 'line',
  BAR: 'bar',
};
